<template>
  <b-row
    no-gutters
    class="d-flex justify-content-center align-items-end editor-toolbar"
  >
    <div class="d-flex h-[256px] w-full">
      <div
        v-if="!file"
        ref="dropzone"
        class="w-full h-full flex flex-col items-center justify-center gap-y-3 mx-auto rounded cursor-pointer transition-all"
        @dragover.prevent="onDragOver"
        @dragleave.prevent="onDragLeave"
        @drop.prevent="onDrop"
        @click="openFileDialog"
      >
        <input
          ref="fileInput"
          type="file"
          class="hidden"
          @change="onFileChange"
        >
        <svg
          width="136"
          height="136"
          viewBox="0 0 136 136"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          class="text-[#4F83E3] hover:opacity-80"
        >
          <g filter="url(#filter0_d_15531_67751)">
            <rect
              x="4"
              width="128"
              height="128"
              rx="10"
              fill="white"
            />
            <rect
              x="4.75"
              y="0.75"
              width="126.5"
              height="126.5"
              rx="9.25"
              stroke="currentColor"
              stroke-width="1.5"
            />
            <path
              d="M56.6667 75.3333L68 64M68 64L79.3333 75.3333M68 64V89.5M90.6667 77.438C94.1276 74.5798 96.3333 70.2558 96.3333 65.4167C96.3333 56.8102 89.3564 49.8333 80.75 49.8333C80.1309 49.8333 79.5517 49.5103 79.2373 48.9769C75.5425 42.707 68.7209 38.5 60.9167 38.5C49.1806 38.5 39.6667 48.0139 39.6667 59.75C39.6667 65.604 42.0338 70.9051 45.863 74.7483"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_15531_67751"
              x="0"
              y="0"
              width="136"
              height="136"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood
                flood-opacity="0"
                result="BackgroundImageFix"
              />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite
                in2="hardAlpha"
                operator="out"
              />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_15531_67751"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_15531_67751"
                result="shape"
              />
            </filter>
          </defs>
        </svg>

        Upload Backup File...

        <div
          v-if="fileError"
          class="mt-2 text-danger text-sm"
        >
          {{ fileError }}
        </div>
      </div>


      <div
        v-else
        class="w-full flex flex-col items-center justify-center gap-y-2"
      >
        <p class="text-center text-base text-muted">
          {{ file.name }}
        </p>

        <b-btn
          class="min-w-[180px] !text-[15px] font-weight-bold py-2 px-3 d-flex import-page-select items-center justify-center"
          variant="primary"
          type="button"
          @click="restore"
        >
          <svg
            v-if="!loading"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-2"
          >
            <path
              d="M14 6.66667C14 6.66667 12.6633 4.84548 11.5774 3.75883C10.4915 2.67218 8.99093 2 7.33333 2C4.01962 2 1.33333 4.68629 1.33333 8C1.33333 11.3137 4.01962 14 7.33333 14C10.0687 14 12.3766 12.1695 13.0988 9.66667M14 6.66667V2.66667M14 6.66667H10"
              stroke="white"
              stroke-width="1.3"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <b-spinner
            v-else
            class="ml-2"
            small
          />
          Restore
        </b-btn>
      </div>
    </div>
  </b-row>
</template>

<script>
export default {
  name: 'BackupPage',
  data () {
    return {
      loading: false,
      file: null,
      isDragging: false,
      fileError: '',
      allowedExtensions: ['json']
    }
  },
  methods: {
    openFileDialog () {
      if (this.$refs.fileInput) {
        this.$refs.fileInput.click()
      }
    },
    onDragOver () {
      this.isDragging = true
    },
    onDragLeave () {
      this.isDragging = false
    },
    onDrop (event) {
      this.isDragging = false
      const files = event.dataTransfer && event.dataTransfer.files
      if (!files || !files.length) return

      const file = files[0]
      this.handleFile(file)
    },
    onFileChange (event) {
      const files = event.target.files
      if (!files || !files.length) return

      const file = files[0]
      this.handleFile(file)
    },
    handleFile (file) {
      this.fileError = ''

      if (!file || !file.name) {
        this.file = null
        this.fileError = 'No file selected.'
        return
      }

      const parts = file.name.split('.')
      const extension = parts.length > 1 ? parts.pop().toLowerCase() : ''

      if (!this.allowedExtensions.includes(extension)) {
        this.file = null
        this.fileError = `Invalid file type: .${extension || 'unknown'}. Please upload a .${this.allowedExtensions.join(', .')} backup file.`
        return
      }

      this.file = file
    },
    async restore () {
      this.loading = true

      try {
        const reader = new FileReader()
        reader.readAsText(this.file)
        reader.onload = async () => {
          const page = JSON.parse(reader.result)
          await this.$store.dispatch('backups/restorePageByFile', page)
        }

        this.$emit('page-added')
        this.$emit('backup')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>